export default __webpack_public_path__ + "static/media/product_avtar_Cn.e786710d.webp";